import styled from 'styled-components';

export const Heading = styled.h1`
    display: flex;
    justify-content: center;
    align-items: center;

    font-family: Josefin Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 6vh;
    line-height: 5vh;

    color: #002140;
    padding: 40px 0px 0px 0px;
`;

export const Subheading = styled.h2`
    display: flex;
    justify-content: center;
    align-items: center;

    font-family: Josefin Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 3vh;
    line-height: 0px;

    color: #BBDAFF;
    padding: 30px 0px 40px 0px;
`;